import axios from "axios";

const DASHBOARD_USER_KEY = "dashboardUser";

// Set up the interceptor once — it reads the token from localStorage on each request
axios.interceptors.request.use((config) => {
  const method = config.method.toUpperCase();
  if (
    method === "GET" ||
    method === "POST" ||
    method === "PATCH" ||
    method === "DELETE"
  )
    config.headers["Content-Type"] = "application/json;charset=utf-8";

  const token = localStorage.getItem("accessToken");
  if (token) config.headers.Authorization = "Bearer " + token;

  return config;
});

export const putAccessToken = (accessToken) => {
  localStorage.setItem("accessToken", accessToken);
};

export const clearAccessToken = () => {
  localStorage.removeItem("accessToken");
};

export const putDashboardUser = (user) => {
  localStorage.setItem(DASHBOARD_USER_KEY, JSON.stringify(user));
};

export const getDashboardUser = () => {
  const storedUser = localStorage.getItem(DASHBOARD_USER_KEY);
  if (!storedUser) {
    return null;
  }

  try {
    return JSON.parse(storedUser);
  } catch (error) {
    clearDashboardUser();
    return null;
  }
};

export const clearDashboardUser = () => {
  localStorage.removeItem(DASHBOARD_USER_KEY);
};
